<template>
  <autocomplete
    v-model="selectedCompanies"
    :items="foodCompanies"
    :label="$t('select_company')"
    item-text="name"
    item-value="id"
    selectable-all
    clearable
    hide-details
    chips
    return-object
    deletable-chips
    multiple
    prepend-item
    :loading="loading.fetchFoodCompanies"
    :disabled="loading.fetchFoodCompanies"
  >
    <template v-slot:prepend-item>
      <v-list-item
        @click="toggleAllCompanies"
        style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"
        :disabled="loading.fetchFoodCompanies"
      >
        <v-list-item-action>
          <v-checkbox
            :value="selectedCompanies.length === foodCompanies.length"
            :disabled="loading.fetchFoodCompanies"
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-title>
          {{ $t("display_all") }}
        </v-list-item-title>
      </v-list-item>
    </template>
  </autocomplete>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: {
        fetchFoodCompanies: false,
      },
    };
  },
  methods: {
    toggleAllCompanies() {
      if (this.loading.fetchFoodCompanies) return;
      
      if (this.selectedCompanies.length) {
        this.selectedCompanies = [];
      } else {
        this.selectedCompanies = this.foodCompanies;
      }
    },
    fetchFoodCompanies() {
      if (this.loading.fetchFoodCompanies) return;
      
      this.loading.fetchFoodCompanies = true;
      this.$store
        .dispatch("report/fetchFoodCompanies", {
          date_from: this.filters.dates.from,
          date_to: this.filters.dates.to,
          restaurant_id: this.restaurantId,
        })
        .then(() => {
          if (
            this.foodCompanies &&
            this.foodCompanies.length &&
            !this.selectedCompanies.length
          ) {
            this.$store.commit("report/SET_SELECTED_FOOD_COMPANIES", this.foodCompanies);
          }
        })
        .catch((error) => {
          console.error("Error fetching food companies:", error);
        })
        .finally(() => {
          this.loading.fetchFoodCompanies = false;
        });
    },
  },
  computed: {
    foodCompanies() {
      const companies = this.$store.state.report.foodCompanies || [];
      if (this.items.length) {
        return companies
          .filter((company) => this.items.includes(company.id))
          .map((company) => ({
            ...company,
            name: this.toLatin(company.name),
          }));
      }
      return companies.map((company) => ({
        ...company,
        name: this.toLatin(company.name),
      }));
    },
    selectedCompanies: {
      get() {
        return this.$store.state.report.selectedFoodCompanies;
      },
      set(val) {
        this.$store.commit("report/SET_SELECTED_FOOD_COMPANIES", val);
      },
    },
    selectedCompaniesProxy: {
      get() {
        return this.selectedCompanies;
      },
      set(val) {
        this.selectedCompanies = val;
      },
    },
    restaurantId() {
      return this.$store.state.restaurant.id;
    },
    filters() {
      return this.$store.state.report.filters;
    },
  },
  watch: {
    restaurantId: {
      handler(newVal) {
        if (this.foodCompanies.length || !newVal) return;
        this.fetchFoodCompanies();
      },
      immediate: true,
    },

    "filters.dates": {
      handler() {
        if (this.foodCompanies.length) return;
        this.fetchFoodCompanies();
      },
      deep: true,
    },
  },
};
</script>
